import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { AdminPspSubscription } from 'src/app/_models/PSP/Psp-Task-Details.model';
import { AreaService } from 'src/app/_services/area.service';
import { CityService } from 'src/app/_services/city.service';
import { FilesService } from 'src/app/_services/files/files.service';
import { PspTasksService } from 'src/app/_services/PSP/psp-tasks.service';
import { baseUrl } from 'src/environments/environment';

@Component({
  selector: 'app-pending-carereceiver',
  templateUrl: './pending-carereceiver.component.html',
  styleUrls: ['./pending-carereceiver.component.scss'],
})
export class PendingCarereceiverComponent implements OnInit {
  relations = [];
  cities = [];
  areas = [];

  task: AdminPspSubscription;
  constructor(
    private pspTaskService: PspTasksService,
    private activatedRoute: ActivatedRoute,
    private areaService: AreaService,
    private cityService: CityService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService,
    private filesService: FilesService
  ) {}

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.params.id) {
      this.spinner.show();
      const params = {
        subscriptionId: this.activatedRoute.snapshot.params.id,
      };
      // TODO! To be switched to use RxJs
      this.cityService.getAllCities().subscribe((res) => {
        this.cities = [...res];

        this.areaService.getAllAreas().subscribe((res2) => {
          this.areas = [...res2.data.areas];
          this.pspTaskService.getPspRelations().subscribe((res3) => {
            this.relations = res3?.data.relations;
          });

          this.pspTaskService.getSubscriptionById(params).subscribe((res4) => {
            this.task = res4.data;
            this.task.rxPath = this.task.rxPath;
            let birthdateData = this.task.patientReceiver.dateOfBirth.toString().split("/")
            let patientBirthdate = `${birthdateData[1]}/${birthdateData[0]}/${birthdateData[2]}`

            this.task.patientReceiver.dateOfBirth = this.task.patientReceiver.dateOfBirth
              ? new Date(patientBirthdate)
              : null;
            this.spinner.hide();
          });
        });
      });
    }
  }

  onCopy() {
    const copyText = this.task.patient.phone;

    navigator.clipboard.writeText(copyText);
  }

  onUpdateTask(isApproved) {
    this.spinner.show();
    const body = {
      id: +this.activatedRoute.snapshot.params.id,
      doctorId: this.task.doctor?.id,
      doctorName: this.task.doctor?.name,
      hospitalId: this.task.hospital?.id,
      hospitalName: this.task.hospital?.name,
      isApproved,
    };
    this.pspTaskService.updatePspSubscription(body).subscribe((res) => {
      showNotification(
        'success',
        `${isApproved ? 'Task has been Approved' : 'Task has been Rejected'} `,
        this.toastr
      );
      this.spinner.hide();
      this.router.navigateByUrl('psp/daily-tasks');

    });
  }

  downloadNationalIds(){
    this.task.nationalIdPaths?.forEach(f => this.filesService.downloadFile(f));
  }

  downloadMedicalReports(){
    this.task.medicalReportPaths?.forEach(f => this.filesService.downloadFile(f));
  }
}
